import { render, staticRenderFns } from "./EditorExpresiones.vue?vue&type=template&id=2c6766b3&scoped=true"
import script from "./EditorExpresiones.vue?vue&type=script&lang=js"
export * from "./EditorExpresiones.vue?vue&type=script&lang=js"
import style0 from "./EditorExpresiones.vue?vue&type=style&index=0&id=2c6766b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6766b3",
  null
  
)

export default component.exports